import currencySymbol from './currencySymbol'

export default currencySymbol
